
export function getEntities()
{
    try
    {
        let tok = localStorage.getItem('token').replaceAll('"', "")
        //console.log(tok)
        return  fetch(`${process.env.REACT_APP_APIDrug4dents_URL}imgateway/entities?herbs=true&drugs=true&drugclass=true`,
        {
    
            method:"GET",
            headers: {
                 'Authorization':`Bearer ${localStorage.getItem('sessionId').replaceAll('"', "")} ${localStorage.getItem('Activecountryversion').replaceAll(" ", "")}`
            }
        })
        .then(data => data.json())
    }
    catch(error)
    {
        return [];
    }
}
export async function gatewayInteraction(inputs,interactingEntities,fetchPage)
{
    try
    {
        //console.log('gateway fetch inputs:', inputs, interactingEntities)
        let response = await fetch(`${process.env.REACT_APP_APIDrug4dents_URL}imgateway/interaction?page=${(fetchPage)} `,
        {
            method:"POST",
            body:JSON.stringify({
                'inputs':inputs,
                'interactingEntities':interactingEntities
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization':`Bearer ${localStorage.getItem('sessionId').replaceAll('"', "")} ${localStorage.getItem('Activecountryversion').replaceAll(" ", "")}`
            }
        })
        //console.log(response.json());
        var count = parseInt(response.headers.get('total-count'));
        var page = parseInt(response.headers.get('page-index'));
        var status = response.status;
        let json = await response.json();
        return {status:status, count:count, page:page, data:json};
        
    }
    catch(error)
    {
        return {status:0, count:0, page:0, data:[]};
    }
}
export async function getInteraction(inputs,fetchPage) {
    try
    {
        //console.log('interaction fetch inputs:', inputs)
        let res = await fetch(`${process.env.REACT_APP_APIDrug4dents_URL}drugInteraction?page=${(fetchPage)}&limit=5`,
        {
            method:"POST",
            body:JSON.stringify({
               'inputs':inputs
            }),
            headers: {
                'Content-Type': 'application/json',
                 'Authorization':`Bearer ${localStorage.getItem('sessionId').replaceAll('"', "")} ${localStorage.getItem('Activecountryversion').replaceAll(" ", "")}`,
            }
        });

        let json = await res.json();
        var count = parseInt(res.headers.get('total-count') ?? 0);
        var page = parseInt(res.headers.get('page-index'));
        return {success:true, count:count, page:page, data:json};
        
    }
    catch(error)
    {
       return {success:false, count:0, page:0, data:[]};
    }
}
export async function getInteractionVP(inputs, fetchPage = 1, rowsPerPage = 5) {  //  Default to 5
    console.log(rowsPerPage)
    try {
        let res = await fetch(
            `${process.env.REACT_APP_APIDrug4dents_URL}d4d/drugInteraction?page=${fetchPage}&limit=${rowsPerPage}`,
            {
                method: "POST",
                body: JSON.stringify({ inputs }),
                headers: {
                    "Content-Type": "application/json",
                    'Authorization':`Bearer ${localStorage.getItem('sessionId').replaceAll('"', "")} ${localStorage.getItem('Activecountryversion').replaceAll(" ", "")}`,
                },
            }
        );

        let json = await res.json();
        var count = parseInt(res.headers.get("total-count") ?? "0", 10);
        var page = parseInt(res.headers.get("page-index") ?? "1", 10);

        return { success: true, count, page, data: json };
    } catch (error) {
        console.error("API Error:", error);
        return { success: false, count: 0, page: 1, data: [] };
    }
}



export async function getAllergyInteractions(inputs, allergens, fetchPage = 1, rowsPerPage = 5) { // Default fetchPage to 1, rowsPerPage to 5
    try {
        
        let response = await fetch(
            `${process.env.REACT_APP_APIDrug4dents_URL}drugAllergy?page=${fetchPage}&limit=${rowsPerPage}`,
            {
                method: "POST",
                body: JSON.stringify({ inputs, allergens }),
                headers: {
                    "Content-Type": "application/json",
                    'Authorization':`Bearer ${localStorage.getItem('sessionId').replaceAll('"', "")} ${localStorage.getItem('Activecountryversion').replaceAll(" ", "")}`
                },
            }
        );

        let json = await response.json();
        let count = parseInt(response.headers.get("total-count") ?? "0", 10);
        let page = parseInt(response.headers.get("page-index") ?? "1", 10);
        let status = response.status;

        return { success: true, status, count, page, data: json };
    } catch (error) {
        console.error("API Error:", error);
        return { success: false, status: 0, count: 0, page: 1, data: [] };
    }
}

export async function getDrugInfo(input) {
    try
    {
        let response = await fetch(`${process.env.REACT_APP_APIDrug4dents_URL}drugInfo/afe3f563-6aa4-4615-8d60-affd00f52334`,
        {
            method:"GET",
            headers: { 'Authorization':`Bearer ${localStorage.getItem('sessionId').replaceAll('"', "")} ${localStorage.getItem('Activecountryversion').replaceAll(" ", "")}`}
        });
        return await response.json();
    }
    catch(error)
    {
        return  [];
    }
}

export async function getInteractionsDisclaimer(url)
{
   try
   {
       return await fetch(url,
       {
           method: "GET"
       }).then(data => data.json())
   }
   catch (error)
   { return [] }
}
